import React from "react";
import ReactMarkdown from "react-markdown";
export default function MarkdownInstructions({ instructions }) {
  return <ReactMarkdown>{instructions}</ReactMarkdown>;
}
